query PlatformPagesList(
  $page: Int
  $rowsPerPage: Int
  $filter: PlatformPagesFilterInput
) {
  platformPages(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    nodes {
      id
      title
      path
      url
      description
      publishAt
      createdAt
      updatedAt
      image {
        id
        url(format: SMALL)
      }
      visibilityConditions {
        userType
        countries {
          type
          countryCodes
        }
        applicationPlatforms {
          type
          platforms
        }
      }
    }
    count
  }
}

